export const Config = {
    //domainApi: "http://127.0.0.1:81", // local
    // domainApi: "http://13.127.231.201:8081", // test
    domainApi: "https://admin.winlottery.cc/api", // prod
};